import React from "react";
import Menu from "../Menu";
import CommonSendComponent from "../../components/CommonSendComponent";
import { getSendConfig } from "../../Configs/SendConfigs";

const SendCatelog = () => {
  const config = getSendConfig('catalog');

  return (
    <>
      <Menu />
      <CommonSendComponent config={config} />
    </>
  );
};

export default SendCatelog;
